<template>
  <div id="sketch-view-modal" class="modal"  v-show="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main">
      <div class="title-area" id="modal-moving">
        <h2>スケッチオーダー 情報画面</h2>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <div class="data-area">
        <ul>
          <li class="sub-menu">
            <span>★基本情報</span>
          </li>
          <li>
            <span class="label">プランID</span>
            <span>{{ form.planId }}</span>
          </li>
          <li>
            <span class="label">会社名</span>
            <span>{{ form.corpName }}</span>
          </li>
          <li>
            <span class="label">お客様名</span>
            <span>{{ form.userName }}</span>
          </li>
          <li class="sub-menu">
            <span>★追加情報</span>
          </li>
          <li>
            <span class="label">依頼時お客様コメント</span>
            <textarea type="text" v-model="form.sketchComment" rows="10" :disabled=true></textarea>
          </li>
          <li class="sub-menu">
            <span>★スケッチ画像</span>
          </li>
          <li v-if="form.sketchImg1">
            <span class="label">スケッチ１</span>
            <span>
              <a @click.prevent="fileOpen(form,form.sketchImg1,form.imgMime1)"><img :src="getImage('pages/list/icon_file.png')" width="22px" height="auto"></a>
              <a @click.prevent="fileDownload(form,form.sketchImg1)"><img :src="getImage('pages/list/download.png')" width="22px" height="auto"></a>
              {{ form.sketchImg1 }}
            </span>
          </li>
          <li v-if="form.sketchImg2">
            <span class="label">スケッチ２</span>
            <span>
              <a @click.prevent="fileOpen(form,form.sketchImg2,form.imgMime2)"><img :src="getImage('pages/list/icon_file.png')" width="22px" height="auto"></a>
              <a @click.prevent="fileDownload(form,form.sketchImg2)"><img :src="getImage('pages/list/download.png')" width="22px" height="auto"></a>
              {{ form.sketchImg2 }}
            </span>
          </li>
          <li v-if="form.sketchImg3">
            <span class="label">スケッチ３</span>
            <span>
              <a @click.prevent="fileOpen(form,form.sketchImg3,form.imgMime3)"><img :src="getImage('pages/list/icon_file.png')" width="22px" height="auto"></a>
              <a @click.prevent="fileDownload(form,form.sketchImg3)"><img :src="getImage('pages/list/download.png')" width="22px" height="auto"></a>
              {{ form.sketchImg3 }}
            </span>
          </li>
          <li v-if="form.sketchImg4">
            <span class="label">スケッチ４</span>
            <span>
              <a @click.prevent="fileOpen(form,form.sketchImg4,form.imgMime4)"><img :src="getImage('pages/list/icon_file.png')" width="22px" height="auto"></a>
              <a @click.prevent="fileDownload(form,form.sketchImg4)"><img :src="getImage('pages/list/download.png')" width="22px" height="auto"></a>
              {{ form.sketchImg4 }}
            </span>
          </li>
          <li v-if="form.sketchImg5">
            <span class="label">スケッチ５</span>
            <span>
              <a @click.prevent="fileOpen(form,form.sketchImg5,form.imgMime5)"><img :src="getImage('pages/list/icon_file.png')" width="22px" height="auto"></a>
              <a @click.prevent="fileDownload(form,form.sketchImg5)"><img :src="getImage('pages/list/download.png')" width="22px" height="auto"></a>
              {{ form.sketchImg5 }}
            </span>
          </li>
        </ul>
      </div>
      <div class="button-area">
        <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as AppUtil from '../../utils/App'
import {API_URL} from '../../constants/App'
import LoadingModal from '../common/LoadingModal'

export default {
  name: 'SketchAddCartModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      form: {
        fdId: '',
        corpId: '',
        planId: '',
        corpName: '',
        userName: '',
        sketchComment: '',
        sketchImg1: '',
        sketchImg2: '',
        sketchImg3: '',
        sketchImg4: '',
        sketchImg5: '',
        imgMime1: '',
        imgMime2: '',
        imgMime3: '',
        imgMime4: '',
        imgMime5: ''
      },
      errorMessages: [],
      validateErrorMessages: {}
    }
  },
  watch: {
    modalShown: function () {
      if (this.modalShown) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    /** 新規モーダル */
    showModal: function (moadlData) {
      this.form = moadlData
      this.modalShown = true
    },
    /** キャンセル */
    onCancel: function () {
      this.clearData()
      this.modalShown = false
    },
    /** スケッチ画像のダウンロード */
    fileDownload: function (form, filename) {
      this.$refs.loadingModalRef.showModal(true)
      axios({
        method: 'POST',
        url: API_URL.LIST + '/sketchDownload',
        responseType: 'blob',
        data: {
          sketchCorpId: form.corpId,
          sketchFdId: form.fdId,
          sketchFileName: filename
        }
      }).then(response => {
        if (response.data.errorMessage) {
          this.handleErrorMessage(response)
        } else {
          var data = response.data
          let blob = new Blob([data], {type: 'application/octet-stream;charset=SJIS'})
          if (window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blob, filename)
          } else {
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = filename
            link.click()
          }
        }
      }).catch(error => {
        Api.handleError(error)
      }).finally(() => {
        this.$refs.loadingModalRef.showModal(false)
      })
    },
    /** スケッチ画像の外部表示 */
    fileOpen: function (form, filename, mime) {
      this.$refs.loadingModalRef.showModal(true)
      axios({
        method: 'POST',
        url: API_URL.LIST + '/sketchDownload',
        responseType: 'blob',
        data: {
          sketchCorpId: form.corpId,
          sketchFdId: form.fdId,
          sketchFileName: filename
        }
      }).then(response => {
        if (response.data.errorMessage) {
          this.handleErrorMessage(response)
        } else {
          var data = response.data
          let blob = new Blob([data], {type: mime})
          var fileURL = URL.createObjectURL(blob)
          window.open(fileURL)
        }
      }).catch(error => {
        Api.handleError(error)
      }).finally(() => {
        this.$refs.loadingModalRef.showModal(false)
      })
    },
    getImage: function (image) {
      return AppUtil.getDarosResource(image)
    },
    clearData: function () {
      this.form = {
        fdId: '',
        corpId: '',
        planId: '',
        corpName: '',
        userName: '',
        sketchComment: '',
        sketchImg1: '',
        sketchImg2: '',
        sketchImg3: '',
        sketchImg4: '',
        sketchImg5: '',
        imgMime1: '',
        imgMime2: '',
        imgMime3: '',
        imgMime4: '',
        imgMime5: ''
      }
      this.validateErrorMessages = {}
    }
  }
}
</script>
<style lang="scss" scoped>
.data-area{
    max-height: 580px;
    overflow: auto;
    padding: 20px 140px;
    li {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;
      @media (max-width: 768px) {
        flex-direction: column;
      }
      .label {
        flex: none;
        display: inline-block;
        width: 300px;
        text-align: left;
        font-weight: 500;
        margin-left: 20px;
        margin-top: auto;
        margin-bottom: auto;
        @media (max-width: 768px) {
          text-align: left
        }
      }
      .select-input {
        min-width: 190px;
      }
    }
    .sub-menu {
      margin-top: 30px;
      span {
        font-weight: bold;
      }
    }
  }
.modal-main{
  max-height: 90%;
  min-width: 750px;
  max-width: 800px;
}
.count_limit{
  font-size: 8px;
}
.message{
  margin: 30px;
}
.required {
  color: #ff0000;
}
.validate_error_messages {
  color: #dc3545;
  text-align: left;
  min-width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/SketchViewModal.vue